import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type MigrateShadowSystemRequest,
  type MigrateShadowSystemResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { entitySuggestionKeys, systemKeys } from '../query-keys';

export function useMigrateShadowSystem(suggestionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (data: MigrateShadowSystemRequest): Promise<MigrateShadowSystemResponse> => {
      const { data: response } = await apiClient.post<MigrateShadowSystemResponse>(
        `/api/v2/entity-suggestion/${suggestionId}/migrate-shadow`,
        data
      );
      return response;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: entitySuggestionKeys.shadowSystems() });
      // A 'new'-mode resolution mints a System — refresh the systems list so it
      // appears without a manual reload.
      qc.invalidateQueries({ queryKey: systemKeys.lists() });
    }
  });
}
